import type { UserLevel } from '@/types/users'

/** Mirrors auth USER_LEVELS (escribonauta-auth/services/constants/levels.ts). */
export const USER_LEVELS = {
  BASIC: 'basic',
  ADDS_FREE: 'adds free',
  PREMIUM_1: 'premium level 1',
  PREMIUM_2: 'premium level 2',
} as const satisfies Record<string, UserLevel>

/** Premium level 1 or 2 (paid plans). */
export function hasPremiumAccess(level: UserLevel | string | null | undefined): boolean {
  return level === USER_LEVELS.PREMIUM_1 || level === USER_LEVELS.PREMIUM_2
}

export function isFreeLevel(level: UserLevel | string | null | undefined): boolean {
  return !hasPremiumAccess(level)
}

/** User-facing plan names only. Keep out of variable/API identifiers. */
export const PLAN_UI_LABELS = {
  free: 'Tripulante',
  premium1: 'Capitán',
  premium2: 'Capitán',
} as const

export const PREMIUM_FEATURE_ANALYSIS_TEXT = 'analysis-text-viewer'

export const PREMIUM_PLANS_PATH = '/account?section=plans'
